import ExternalUserDocInput from '@/components/ExternalUserDocInput.vue'
import { createInput } from '@formkit/vue'
export const externalUserDocInput = createInput(ExternalUserDocInput, {
  props: ['docType', 'multiple', 'crewProfileId', 'workspaceId', 'docsLibrary', 'disableTypeCheck']
})
